import * as React from 'react';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { TitleServices, OtherServices, LayoutServices } from '../../components/Services';
import { useTracking } from './tracking';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { BannerWrapper } from '../../components/BannerWrapper';
import { Collapsed } from '../../components/Services/components/Collapsed';
import { useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../types/redux';
import {
  getPrelandingData,
  prelandingToggle,
  setPrelandingId,
  setPrelandingSource,
} from '@cian/frontend-val-my-home-banner';
import { selectServices } from '../../selectors/services';
import { IAdvertisementShelf } from '../../repositories/price-estimator/entities/shelf/AdvertisementShelf';
import { useUserBrowserTheme } from '@cian/ui-kit';

export const ServicesContainer: React.FC = () => {
  const services = useSelector(selectServices);

  const [collapsed, setCollapsed] = React.useState(services.length > 3);

  const dispatch = useDispatch<TThunkDispatch>();
  const isDesktop = useIsDesktop();
  const { trackOtherServicesVisible, trackServiceClick } = useTracking();
  const theme = useUserBrowserTheme();

  const onCollapseHandler = React.useCallback(() => {
    setCollapsed(false);
  }, []);

  const onClickHandler = React.useCallback(
    async (service: IAdvertisementShelf) => {
      const { id, link, prelandingId } = service;
      trackServiceClick(id, prelandingId);

      if (prelandingId) {
        dispatch(setPrelandingId(prelandingId));
        await dispatch(getPrelandingData({ preLandingId: prelandingId }));
        dispatch(prelandingToggle(true));
        dispatch(setPrelandingSource('myhomeShelfServices'));
      } else {
        window.open(link, '_blank');
      }
    },
    [dispatch, trackServiceClick],
  );

  return (
    <ActionAfterViewObserver callback={trackOtherServicesVisible} callbackDelay={1500}>
      <>
        {isDesktop && <TitleServices title="Может пригодиться" />}
        {isDesktop && <BannerWrapper />}
        <LayoutServices>
          {(collapsed && isDesktop ? services.slice(0, 3) : services).map(service => {
            return (
              <OtherServices
                key={service.id}
                title={service.title}
                iconLink={theme === 'dark' ? service.darkIconLink : service.iconLink}
                onClick={() => onClickHandler(service)}
                isDesktop={false}
                filled={!isDesktop}
              />
            );
          })}
        </LayoutServices>
        {collapsed && isDesktop && <Collapsed onClick={onCollapseHandler} />}
      </>
    </ActionAfterViewObserver>
  );
};

ServicesContainer.displayName = 'ServicesContainer';
